import { EstablecimientoInterface } from '../../../models/establecimiento.model';
import { Component, inject, signal } from '@angular/core';
import { CrudEditComponent } from '../../../shared/components/crud/edit/edit.component';
import { ActivatedRoute } from '@angular/router';
import { ESTABLECIMIENTOS_FIELDS_FORM } from '../../../constants/establecimientos.constants';
import { EstablecimientosService } from '../../../core/establecimientos.service';
import { ModalidadService } from '../../../core/modalidad.service';

@Component({
  selector: 'app-establecimientos-edit',
  imports: [CrudEditComponent],
  templateUrl: './establecimientos-edit.component.html',
  styleUrls: ['./establecimientos-edit.component.scss']
})
export class EstablecimientosEditComponent {
  id = signal('');
  fields = ESTABLECIMIENTOS_FIELDS_FORM;
  establecimientosService = inject(EstablecimientosService);
  establecimiento!: EstablecimientoInterface;
  modalidadService = inject(ModalidadService);
  private activatedRoute = inject(ActivatedRoute);
  constructor() {
    this.activatedRoute.params.subscribe((params) => {
      this.id.set(params['id']);
    });
  }
  ngOnInit() {
    this.establecimientosService.getById(Number(this.id())).subscribe((data) => {
      this.establecimiento = <EstablecimientoInterface>data;
    });
    this.modalidadService.getAllForSelect().subscribe((data)=>{
      this.fields['modalidad_id'].options = data;
    });
  }
}
